import { Requests } from "../common/request.common";
import { AttendanceResponseTypes } from "../common/response.common";
import { post } from "./common";

export const attendance = {
    record(data: typeof Requests.Attendance.Record.Input) {
        return post<typeof data, AttendanceResponseTypes.Record>("/attendance/record", data);
    },
    verifyManualAttendance(data: typeof Requests.Attendance.AddManualAttendance.Input) {
        return post<typeof data, AttendanceResponseTypes.VerifyManualAttendance>(
            "/attendance/manual/verify",
            data,
        );
    },
    addManualAttendance(data: typeof Requests.Attendance.AddManualAttendance.Input) {
        return post<typeof data, AttendanceResponseTypes.AddManualAttendance>(
            "/attendance/manual/add",
            data,
        );
    },
    createReport(data: typeof Requests.Attendance.CreateAttendancesReport.Input) {
        return post<typeof data>("/attendance/report/create", data, {
            authenticated: true,
            downloadable: true,
            responseType: "arraybuffer",
        });
    },
};
